/**
 * Legacy internal paths that should point at a different page on this theme.
 * Matched case-insensitively, ignoring a trailing slash; any query string or
 * hash on the original href is preserved.
 */
const PATH_REDIRECTS: Record<string, string> = {
  '/tour': '/schedule-a-tour',
  '/schedule-tour': '/schedule-a-tour',
};

export function resolveHref(href: string): string;
export function resolveHref(href: string | null | undefined): string | undefined;
export function resolveHref(href: string | null | undefined): string | undefined {
  if (!href) return href ?? undefined;
  const trimmed = href.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return href;
  const match = trimmed.match(/^([^?#]*)(.*)$/);
  const path = (match?.[1] ?? trimmed).toLowerCase().replace(/\/+$/, '');
  const target = PATH_REDIRECTS[path];
  return target ? `${target}${match?.[2] ?? ''}` : href;
}

/** Rewrite matching `<a href>` values inside rendered DOM (for inherited
 *  components and richtext whose hrefs this theme doesn't render itself). */
export function rewriteLegacyLinks(root: ParentNode = document): void {
  root.querySelectorAll<HTMLAnchorElement>('a[href^="/"]').forEach((a) => {
    const href = a.getAttribute('href');
    const next = resolveHref(href);
    if (next && next !== href) a.setAttribute('href', next);
  });
}
